<p-card header="Area protetta" subheader="Accessibile solo agli utenti autenticati">
  <p>
    Qui potrai mostrare i dati provenienti da <strong>Firestore</strong> visibili solo agli utenti
    loggati con <strong>Auth0</strong>.
  </p>
</p-card>


